import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsLetterAddress } from 'common/customers/services/types/RsLetterAddress';
import { RsLetterAddressInfo } from 'common/customers/services/types/RsLetterAddressInfo';
import { LetterAddressAdd } from 'common/customers/services/types/LetterAddressAdd';
import { LetterAddressUpdate } from 'common/customers/services/types/LetterAddressUpdate';

export function letterAddressFromGetToUpdateParams(params: RsLetterAddressInfo): LetterAddressAdd {
    return {
        defaultForSex: params.defaultForSex,
        name: params.name,
        nameLatin: params.nameLatin,
        orderNo: params.orderNo,
        sex: params.sex
    };
}

export type ILetterAddressDataProvider = IDataProviderV2<RsLetterAddress, RsLetterAddressInfo, LetterAddressAdd, LetterAddressUpdate>;

export class LetterAddressDataProvider
    extends AbstractDataProviderV2<RsLetterAddress, RsLetterAddressInfo, LetterAddressAdd, LetterAddressUpdate>
    implements ILetterAddressDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/letter-addresses');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
